<template>
  <div class="vote d-flex flex-column justify-content-center text-center">
    <a
      class="vote-up-off"
      :class="{ active: voted.up }"
      @click="voteWish(true)"
    >
      <i class="fas fa-caret-up"></i>
    </a>

    <span class="vote-count-post vote-margin">{{ counter }}</span>

    <a
      class="vote-down-off vote-margin"
      :class="{ active: voted.down }"
      @click="voteWish(false)"
    >
      <i class="fas fa-caret-down"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: ["wish"],
  data() {
    return {
      counter: parseInt(this.wish.counter),
      voted: {
        up: this.wish.upOrDown == 1 ? true : false,
        down: this.wish.upOrDown == -1 ? true : false,
      },
      double: this.wish.upOrDown ? true : false,
      upOrDownUrl: null,
    };
  },
  methods: {
    voteWish(up) {
      if (!window.App.user) {
        window.bus.$emit("authMsg", {
          msg: "იმისათვის, რომ შეძლოთ ხმის მიცემა გთხოვთ გაიაროთ ავტორიზაცია",
        });
        showRegister();
        return;
      }
      // if(window.App.user.id == this.wish.user_id) return alert('tqveni')
      if (up) {
        if (this.voted.up) return;
        this.double ? (this.counter += 2) : (this.counter += 1);
        this.upOrDownUrl = "up";
        this.voted = { up: true, down: false };
        this.double = true;
      } else {
        if (this.voted.down) return;
        this.double ? (this.counter -= 2) : (this.counter -= 1);
        this.upOrDownUrl = "down";
        this.voted = { up: false, down: true };
        this.double = true;
      }
      this.postVote();
    },

    postVote() {
      axios.post(`/feedback/vote${this.upOrDownUrl}/${this.wish.id}`);
    },
  },
  mounted() {},
};
</script>
